module.exports = __webpack_public_path__ + "static/media/img-algo-es.151b8314.png";